export const iconSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export default iconSizes;
